import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';

export type GhostTextSlots = {
  root: Slot<'span'>;
  indicator?: Slot<'span'>;
};

/**
 * GhostText Props
 */
export type GhostTextProps = ComponentProps<GhostTextSlots> & { nodeKey?: string };

/**
 * State used in rendering GhostText
 */
export type GhostTextState = ComponentState<GhostTextSlots>;
// TODO: Remove semicolon from previous line, uncomment next line, and provide union of props to pick from GhostTextProps.
// & Required<Pick<GhostTextProps, 'propName'>>
